var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5H15.5452V0H0.5V5ZM0.5 15H15.5452V10H0.5V15ZM0.5 25H15.5452V20H0.5V25ZM20.5226 25H25.5V20H20.5226V25ZM20.5226 0V5H25.5V0H20.5226ZM20.5226 15H25.5V10H20.5226V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToc);
export default __webpack_public_path__ + "static/media/toc.a8bc2b51e4a32f8dfce9801ff928a383.svg";
export { ForwardRef as ReactComponent };